import gql from 'graphql-tag'
import { comunicadoEnvioFragment } from '../../comunicado-core/data/comunicado-envio-fragment'

export const COMUNICADO_ENVIOS_RECENTES_QUERY = gql`
  query ComunicadoEnviosRecentesQuery {
    comunicadoEnviosRecentes {
      ...ComunicadoEnvioFragment
    }
  }
  ${comunicadoEnvioFragment}
`
